export default "__VITE_ASSET__d3ea1267__"